<script>
import ServiceColumn from "@/components/navigation/private/ServiceColumn.vue";
import SubServiceColumn from "@/components/navigation/private/SubServiceColumn.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "NavigationDrawerOverlay",
  components: {SubServiceColumn, ServiceColumn},
  computed: {
    ...mapGetters('navigation', ['getServices', 'getSubServices']),
  },
  methods: {
    ...mapActions('navigation', ['setSelectedServiceAreaId']),
    handleClick() {
      this.setSelectedServiceAreaId(null)
    }
  },
}
</script>

<template>
  <div id="navigation-overlay" class="d-flex">
      <div class="overlay-menu-content">
        <v-btn class="close-menu-btn" icon aria-label="Close menu" @click="handleClick">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <service-column v-if="getServices" />
        <sub-service-column v-if="getServices && getSubServices" />
      </div>
      <div class="overlay-click-target" @click="handleClick"></div>
  </div>
</template>

<style scoped>
.overlay-menu-content {
  display: flex;
  position: relative;
}

.close-menu-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  color: #b40055;
}

.overlay-click-target {
  height: 100vh;
  flex: 1;
}
</style>
